export enum StorefrontWidgetCheckboxIconPosition {
  TitleRight = "title_right",
  DescriptionRight = "description_right",
}
